
export default {
  title: {
    type: 'Label',
    name: '7',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '15px'
  },
  name: {
    type: 'Paragraph',
    name: '1',
    fontSize: 34,
    fontWeight: 700,
    lineHeight: '42.5px',
    md: {
      fontSize: 26,
      fontWeight: 700,
      lineHeight: '32.5px'
    }
  },
  bio: {
    type: 'Paragraph',
    name: '3',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '24px'
  },
  contact: {
    type: 'Paragraph',
    name: '6',
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '17.5px'
  }
}
